import { render, staticRenderFns } from "./myCard.vue?vue&type=template&id=1499a9b4&scoped=true"
import script from "./myCard.vue?vue&type=script&lang=js"
export * from "./myCard.vue?vue&type=script&lang=js"
import style0 from "./myCard.vue?vue&type=style&index=0&id=1499a9b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1499a9b4",
  null
  
)

export default component.exports